import { render, staticRenderFns } from "./link-collection-minimal.vue?vue&type=template&id=3d6c08af&"
import script from "./link-collection-minimal.vue?vue&type=script&lang=js&"
export * from "./link-collection-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports